import script from "./RcButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcButton.vue?vue&type=script&setup=true&lang=ts"

import "./RcButton.vue?vue&type=style&index=0&id=0e036b9c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e036b9c"]])

export default __exports__